import { useEffect, useState } from "react";
import {
  getParaplanningCatalogById,
  getParaplanningCatalogs,
} from "../services/paraplanningChargesService";

export const useParaplanningCharges = (activeCatalogId) => {
  const [catalogs, setCatalogs] = useState([]);
  const [loadingCharges, setLoadingCharges] = useState(false);
  const [chargesError, setChargesError] = useState("");

  const fetchCharges = async () => {
    try {
      // console.log("[useParaplanningCharges] Fetch started:", {
      //   activeCatalogId,
      // });

      setLoadingCharges(true);
      setChargesError("");

      if (activeCatalogId) {
        // console.log("[useParaplanningCharges] Fetching single catalog:", {
        //   activeCatalogId,
        // });

        const catalog = await getParaplanningCatalogById(activeCatalogId);

        // console.log("[useParaplanningCharges] Single catalog result:", catalog);

        setCatalogs(catalog ? [catalog] : []);
        return;
      }

      // console.log("[useParaplanningCharges] Fetching all catalogs");

      const allCatalogs = await getParaplanningCatalogs();

      // console.log("[useParaplanningCharges] All catalogs result:", allCatalogs);

      setCatalogs(allCatalogs || []);
    } catch (error) {
      // console.error("[useParaplanningCharges] Error:", error);
      setChargesError(error.message || "Could not load charges.");
    } finally {
      // console.log("[useParaplanningCharges] Fetch finished");
      setLoadingCharges(false);
    }
  };

  useEffect(() => {
    // console.log("[useParaplanningCharges] useEffect fired:", {
    //   activeCatalogId,
    // });

    fetchCharges();
  }, [activeCatalogId]);

  return {
    catalogs,
    loadingCharges,
    chargesError,
    refreshCharges: fetchCharges,
  };
};
